function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("rect", {
  opacity: 0.8,
  width: 32,
  height: 32,
  rx: 16,
  fill: "#DADCDD"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.723 14.055h2.222c.153 0 .277.125.277.278v7.222a.278.278 0 01-.277.278h-2.223a.278.278 0 01-.277-.278v-7.222c0-.153.124-.278.277-.278zm1.1-3.889c.76 0 1.377.622 1.377 1.39 0 .767-.616 1.388-1.377 1.388a1.383 1.383 0 01-1.378-1.389c0-.767.616-1.389 1.377-1.389zm7.788 11.667h1.667a.278.278 0 00.278-.278V16.89c0-2.095-1.184-3.111-2.84-3.111a2.34 2.34 0 00-1.76.705.228.228 0 01-.4-.15.278.278 0 00-.278-.278h-1.667a.278.278 0 00-.277.278v7.222c0 .154.124.278.277.278h1.667a.278.278 0 00.278-.278V17.39a1.389 1.389 0 112.778 0v4.166c0 .154.124.278.277.278z",
  fill: "#192228"
});

function SvgLinkedinGrey(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgLinkedinGrey;